import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../slices/userReducer";
import Cookies from "js-cookie";
import { supabase } from "../supabaseClient";
import InviteSuccessModal from "../components/InviteSuccessModal";

const ProcessInvite = () => {
  const user = useSelector(selectUser);
  const [inviteResult, setInviteResult] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);

  useEffect(() => {
    const processInvite = async () => {
      // Check if user is logged in and there's an invite code
      if (user?.id) {
        const inviteCode = Cookies.get("spinWinInvite");

        if (inviteCode) {
          try {
            // Call an edge function to process the invite
            const { data, error } = await supabase.functions.invoke(
              "processInvite",
              {
                body: JSON.stringify({
                  inviteCode,
                  userId: user.id,
                }),
              }
            );

            if (error) {
              console.error("Error processing invite:", error);
              return;
            }

            if (data.success) {
              // Store the result and show the modal
              setInviteResult(data);
              setShowInviteModal(true);

              // Clear the cookie
              Cookies.remove("spinWinInvite");
            }
          } catch (err) {
            console.error("Failed to process invite:", err);
          }
        }
      }
    };

    processInvite();
  }, [user]);

  return (
    <>
      <InviteSuccessModal
        event={inviteResult?.event}
        prize={inviteResult?.prize}
        onClose={() => setShowInviteModal(false)}
        show={showInviteModal && inviteResult}
      />
    </>
  );
};

export default ProcessInvite;
